<template>
  <div
    v-if="modelBlog?.elements"
    :key="modelBlog?.id+'_contentshow'"
    class="flex flex-col gap-2 ui-scrollbar"
    >

    <Head>
      <Title>{{ modelBlog?.meta?.i18n?.[locale]?.title ?? modelBlog?.title }}</Title
      <Meta
        name="description"
        :content="modelBlog?.meta?.i18n?.[locale]?.description ?? modelBlog?.description"
        />
      <Meta
        property="og:image"
        :content="modelBlog?.image?.url ? `https://www.learn-atc.com${modelBlog.image.url}` : ''"
        />
      <Meta
        property="og:title"
        :content="modelBlog?.meta?.i18n?.[locale]?.title ?? modelBlog?.title"
        />
      <Meta
        property="og:description"
        :content="modelBlog?.meta?.i18n?.[locale]?.description ?? modelBlog?.description"
        />
      <Meta
        property="og:url"
        :content="`https://www.learn-atc.com${route.fullPath}`"
        />
      <Meta
        property="og:type"
        content="article"
        />
    </Head>

    <h1
      v-if="modelBlog.meta && modelBlog.meta.show_title_as_h1"
      v-text="modelBlog?.meta?.i18n?.[locale]?.title ?? modelBlog.title"
      />

    <BlogElements
      v-model:blog="modelBlog"
      v-model:elements="modelBlog.elements"
      />

    <BlogNoContent
      v-model="modelBlog"
      @addbelow="$emit('addbelow',0)"
      />
  </div>
</template>

<script setup lang="ts">

defineEmits(['remove','addbelow','addabove','moveup','movedown'])
const props = defineProps<{
  keeplayout?: boolean
}>()

const { locale } = useI18n()
const route = useRoute()

const modelBlog = defineModel<Blog>()
const dataIsLayoutApplied = ref<boolean>(props.keeplayout as boolean)

const lastLayout = ref<string | null>(null)

const methodAdjustPage = () => {
  // apply layout only if it changed
  const layout = modelBlog.value?.layout
    ? modelBlog.value.layout.toLowerCase().replace(' ', '-')
    : null

  if (import.meta.server && !window && layout) {
    setPageLayout(layout as MaybeRef)
  }

  if (
    !import.meta.client
    || !window
    || dataIsLayoutApplied.value
    || props.keeplayout
  ) { return dataIsLayoutApplied.value = true }

  setTimeout(() => {
    if (layout && layout !== lastLayout.value) {
      setPageLayout(layout as MaybeRef)
    }
    lastLayout.value = layout
  }, 100)


  dataIsLayoutApplied.value = true
}

onRenderTracked(() => {
  setTimeout(() => {
    methodAdjustPage()
  }, 20)
})


watch(() => modelBlog.value, () => methodAdjustPage())

watch(() => modelBlog.value?.elements?.length, () => {
  if(!dataIsLayoutApplied.value) return;

  dataIsLayoutApplied.value = false

  nextTick(() => {
    nextTick(() => {
      dataIsLayoutApplied.value = true
    })
  })
}, { immediate: true, deep: true })

watch(() => modelBlog.value?.elements?.map((e) => e.id), () => {
  if(!dataIsLayoutApplied.value) return;

  dataIsLayoutApplied.value = false

  nextTick(() => {
    modelBlog?.value?.elements?.forEach((element) => {
      if (!element) return;
      element.is_hovering = false
    })

    nextTick(() => {
      dataIsLayoutApplied.value = true
    })
  })
}, { immediate: true, deep: true })

// watch if any readonly state changes
watch(() => modelBlog.value?.elements?.map((e) => e.is_editing), () => {
  if(!dataIsLayoutApplied.value) return;

  nextTick(() => {
    modelBlog?.value?.elements?.forEach((element) => {
      if (!element) return;
      element.is_hovering = false
    })

    nextTick(() => {
      dataIsLayoutApplied.value = true
    })
  })
}, { immediate: true, deep: true })
</script>
